export type ActionRequired = {
  kind:
    | 'invalidConfiguration'
    | 'missingConfiguration'
    | 'deprecatedConfigurationWarning'
    | 'missingEquipment';
  message: string;
  fieldId?: string;
  deprecationKind?: 'javaScriptExpressions';
};

export class ActionRequiredError extends Error {
  public actionRequired: ActionRequired;

  public constructor(actionRequired: ActionRequired) {
    super(actionRequired.message);
    this.actionRequired = actionRequired;
  }
}
